import { Source } from '@rtkwlf/mr-infra-risk';

import type { GridSingleSelectColDef } from '@packages/fenrir/components/datagrid';
import {
  getFilteredGridSelectOperators,
  GridSelectOperator,
} from '@packages/fenrir/components/datagrid';

import { EnumShortListCell } from '../cell/enum-short-list-cell/enum-short-list-cell';
import { translateOptions } from '../translate-options/translate-options';

export const riskSourceOptions = translateOptions(
  Object.values(Source),
  'riskManagement:risks.riskSource',
);

export const riskSourceColumnType: Omit<GridSingleSelectColDef, 'field'> = {
  display: 'flex',
  flex: 0.2,
  minWidth: 115,
  type: 'singleSelect',
  filterOperators: getFilteredGridSelectOperators([GridSelectOperator.isAnyOf]),
  valueOptions: riskSourceOptions,
  renderCell: (params) => (
    <EnumShortListCell
      {...params}
      translationKey="riskManagement:risks.riskSource"
    />
  ),
};
